import React from 'react'
import injectStyles from 'react-jss'

const styles = {
  container: {
    backgroundColor: '#F8F8F8',
    color: 'red',
    padding: 10,
  },
}

const ErrorMessage = ({ classes, children }) => {
  return <div className={classes.container}>{children}</div>
}

export default injectStyles(styles)(ErrorMessage)



// WEBPACK FOOTER //
// ./src/Components/Sync/ErrorMessage.js